import React from 'react'
import PropTypes from 'prop-types'
import GridLib from '@material-ui/core/Grid'
import standardPropTypes from '../DefaultPropTypes'
import flexBoxPropTypes, { defaultFlexBox } from '../FlexBoxPropTypes'
import bootstrapPropTypes, { defaultResponsiveBreakpoints } from '../BootstrapPropTypes'

function Grid({
  children, className, type, xs, sm, md, lg, xl, spacing, flexDirection, justifyContent, alignItems,
}) {
  switch (type) {
    case 'container': return (
      <GridLib
        container
        alignItems={alignItems}
        className={className}
        direction={flexDirection}
        justify={justifyContent}
        spacing={spacing}
      >
        { children }
      </GridLib>
    )
    default: return (
      <GridLib
        item
        className={className}
        md={md}
        lg={lg}
        sm={sm}
        xs={xs}
        xl={xl}
      >
        { children }
      </GridLib>
    )
  }
}

Grid.defaultProps = {
  ...defaultResponsiveBreakpoints,
  ...defaultFlexBox,
  spacing: 0,
}

Grid.propTypes = {
  ...standardPropTypes,
  ...flexBoxPropTypes,
  ...bootstrapPropTypes,
  spacing: PropTypes.oneOf([...Array(11).keys()]),
}

export default Grid
